<!-- @if (invoiceUuid) {
  <app-payment-plans [invoiceUuid]="invoiceUuid"></app-payment-plans>
} -->
<div class="relative bg-white w-full h-full overflow-y-auto md:overflow-hidden" [@rise]>

  <div class="relative w-full h-full" [@stageSwitch]="'invoice_state'">
    @if (invoiceUuid) {
      <app-invoice-plan-upgrade [invoiceUuid]="invoiceUuid"></app-invoice-plan-upgrade>
    }
  </div>
</div>
